import { Immutable } from "immer";
import React from "react";
import { LocationInput } from "tsi-common-react/src/components/LocationInput/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { LOCATION_DIALOG_TITLE_ID } from "../constants";

type IProps = Immutable<{}> & {
    onSubmit?: () => void;
};

export const LocatorSearch = (props: IProps): React.ReactNode => {
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const locationInputID = "location-autocomplete";
    return (
        <form
            className={concatClassNames([FORM_CLASS_NAME, "form--locator"])}
            onSubmit={onSubmit}
        >
            <fieldset>
                <legend
                    className="filters__instruct"
                    id={LOCATION_DIALOG_TITLE_ID}
                >
                    {t`Change your location to find retailers in that area.`}
                </legend>
                <div
                    className={concatClassNames([
                        FORM_FIELD_CLASS_NAME,
                        "filters__inputs",
                    ])}
                >
                    <div className="form__input">
                        <label
                            htmlFor={locationInputID}
                            className="ada-screenreader-only"
                        >
                            {t`Location`}
                        </label>
                        <LocationInput
                            inputProps={{
                                id: locationInputID,
                                placeholder: t`Enter address, city, state or zip`,
                            }}
                            inputFormat="long"
                            onAfterChange={props.onSubmit}
                        />
                    </div>
                </div>
                <div className="filters__actions">
                    <button
                        className="button filters__button"
                        type="submit"
                        aria-label={t`Search`}
                    ></button>
                </div>
            </fieldset>
        </form>
    );
};
